module.exports = __webpack_public_path__ + "static/draegloth-eff50c549390cf520b65c088328e67d0.jpeg";